import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation('home');

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            {t('cta_title')}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mb-8 font-body">
            {t('cta_subtitle')}
          </p>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-10 py-4 bg-secondary-500 text-background-50 rounded-full hover:bg-secondary-600 transition-colors duration-200 font-label font-semibold text-sm whitespace-nowrap cursor-pointer group"
          >
            {t('cta_button')}
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
          </a>
        </div>

        {/* Product image banner */}
        <div className="relative rounded-2xl overflow-hidden h-48 md:h-64">
          <img
            src="https://readdy.ai/api/search-image?query=Horizontal%20flat%20lay%20fashion%20photography%20with%20carefully%20curated%20minimal%20wardrobe%20essentials%20scattered%20on%20warm%20oatmeal%20textured%20backdrop%2C%20cream%20cashmere%20sweater%20beside%20tan%20leather%20loafers%20and%20silver%20watch%2C%20soft%20morning%20light%20from%20left%2C%20editorial%20magazine%20aesthetic%2C%20organic%20lifestyle%20composition%20with%20ample%20negative%20space&width=1800&height=600&seq=cta-banner-v2-2026&orientation=landscape"
            alt="Kakobuy Spreadsheet produkty"
            title="Kakobuy Spreadsheet - produkty i akcesoria"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}